import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import speedMateHttpRequest from "../../network/speedMateHttpRequest";
import { ChangeOnsiteInfoRequestBody } from "./types";

const URL = `/repair-shop/tire-repair-orders`;

/**
 * @author carol
 * 매장 주문 구매 확정
 * 230330, carol
 * @History 화면 고도화 전 유지
 * @History 삭제해도됨
 * @param orderNo
 */
export const confirmPurchase = async (orderNo: string) => {
  await httpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/${orderNo}/confirmed-purchase`,
  });
};
/**
 * @author carol
 * 작업 완료
 * 230330, carol
 * @History confirmPurchase -> completePurchase
 * @param orderNoList
 */
export const completeService = async (orderNo: string) => {
  await httpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/${orderNo}/completed-service`,
  });
};

/**
 * @author carol
 * 일괄 작업 완료
 * 230330, carol
 * @History confirmPurchase -> completePurchase
 * @param orderNoList
 */
export const bulkCompleteService = async (orderNoList: string[]) => {
  const response = await httpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/completed-service-bulk`,
    queryParams: { orderNoList },
  });

  return response?.data.row;
};

/**
 * @author carol
 * 매장 구매 확정 - 스피드메이트
 * 230330, carol
 * @History 화면 고도화 전 유지
 *  @History 삭제해도됨
 * @param orderNo
 */
export const sconfirmPurchase = async (orderNo: string) => {
  await speedMateHttpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/${orderNo}/confirmed-purchase`,
  });
};

/**
 * @author carol
 * 작업 완료 - 스피드메이트
 * 230330, carol
 * @History confirmPurchase -> completeService
 * @param orderNo
 */
export const scompleteService = async (orderNo: string) => {
  await speedMateHttpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/${orderNo}/completed-service`,
  });
};

/**
 * @author carol
 * 일괄 작업 완료 - 스피트메이트
 * @param orderNoList
 */
export const sbulkCompleteService = async (orderNoList: string[]) => {
  const response = await speedMateHttpRequest({
    method: axiosUtils.PUT,
    url: `${URL}/completed-service-bulk`,
    queryParams: { orderNoList },
  });

  return response?.data.row;
};

/**
 * 출장교체 변경 API
 * @param param0
 * @returns
 */
export const putOrderRepairOnSiteByOrderNo = async ({
  orderNo,
  onSitedAt,
}: ChangeOnsiteInfoRequestBody) => {
  const url = `${URL}/${orderNo}/on-site`;

  const response = await httpRequest({
    method: axiosUtils.PATCH,
    url,
    requestBody: { onSitedAt },
  });

  return response?.data;
};
